<template>
  <LazyNuxtPicture
    :src="refinedSrc"
    :width="width"
    :height="height"
    :alt="alt"
    crossorigin="anonymous"
    loading="lazy"
    :img-attrs="{ class: 'h-auto max-w-full bg-grey-500' }"
  ></LazyNuxtPicture>
</template>

<script setup lang="ts">
import { withBase } from 'ufo';
import { useRuntimeConfig, computed } from '#imports';

const props = defineProps({
  src: {
    type: String,
    default: '',
  },
  alt: {
    type: String,
    default: '',
  },
  width: {
    type: [String, Number],
    default: undefined,
  },
  height: {
    type: [String, Number],
    default: undefined,
  },
});

const refinedSrc = computed(() => {
  if (props.src?.startsWith('/') && !props.src.startsWith('//')) {
    return withBase(props.src, useRuntimeConfig().app.baseURL);
  }
  return props.src;
});
</script>
